<template>
  <div class="cpt-core">
    <img :class="$utils.isMobile() ? 'back-img-m' : 'back-img'" src="../assets/about-bg5.png" alt="">
    <div :class="$utils.isMobile() ? 'content-m' : 'content'">
      <div class="list">
        <div class="item" v-for="item in coreData.list" :key="item.id">
          <div :class="$i18n.locale == 'en-US' ? 'item-title-en' : 'item-title'">{{ item.title }}</div>
          <div class="boder-box"></div>
          <div :class="$i18n.locale == 'en-US' ? 'item-txt-en' : 'item-txt'">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt-core',
  data() {
    return {
      coreData: this._contentData.coreData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-core{
  width: 100%;
  display: flex;
  position: relative;
  .back-img{
    width: 100%;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .list{
      background: rgba(64, 126, 160, 0.8);
      border-radius: 30px;
      padding: 50px 0;
      display: flex;
      width: 1200px;
      margin-bottom: 70px;
      .item{
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 25%;
        padding: 0 50px;
        border-right: 1px solid rgba(255, 255, 255, 0.5);
        text-align: center;
        &:last-child{
          border-right: none;
        }
        .item-title{
          font-size: 30px;
          // font-family: MiSans-Medium;
        }
        .item-title-en{
          font-size: 22px;
          // font-family: MiSans-Medium;
        }
        .boder-box{
          width: 25px;
          height: 2px;
          background: #fff;
          margin: 15px 0 25px;
        }
        .item-txt{
          font-size: 22px;
          // font-family: MiSans-Normal;
        }
        .item-txt-en{
          font-size: 16px;
          // font-family: MiSans-Normal;
        }
      }
    }
  }
  .back-img-m{
    height: 420px;
    object-position: 53% 0;
    overflow: hidden;
  }
  .content-m{
    position: absolute;
    top: 0;
    left: 0;
    // width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 30px;
    .list{
      background: rgba(64, 126, 160, 0.8);
      border-radius: 15px;
      padding: 20px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-bottom: 20px;
      width: 100%;
      .item{
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 30px;
        // margin-bottom: 20px;
        width: 50%;
        box-sizing: border-box;
        text-align: center;
        .item-title{
          font-size: 12px;
          // font-family: MiSans-Medium;
        }
        .item-title-en{
          font-size: 10px;
          // font-family: MiSans-Medium;
        }
        .boder-box{
          width: 10px;
          height: 1px;
          background: #fff;
          margin: 10px 0 10px;
        }
        .item-txt{
          font-size: 10px;
          // font-family: MiSans-Normal;
        }
        .item-txt-en{
          font-size: 8px;
          // font-family: MiSans-Normal;
        }
      }
    }
  }
}
</style>